import { render, staticRenderFns } from "./ShippingMethodMinDeliveryDays.vue?vue&type=template&id=491a8911&"
import script from "./ShippingMethodMinDeliveryDays.vue?vue&type=script&lang=ts&"
export * from "./ShippingMethodMinDeliveryDays.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports